import { render, staticRenderFns } from "./KEmptyState.vue?vue&type=template&id=20775e96&scoped=true&"
import script from "./KEmptyState.vue?vue&type=script&lang=js&"
export * from "./KEmptyState.vue?vue&type=script&lang=js&"
import style0 from "./KEmptyState.vue?vue&type=style&index=0&id=20775e96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20775e96",
  null
  
)

export default component.exports